var map = {
	"./arrow-right": 9,
	"./arrow-right.svg": 9,
	"./bag": 10,
	"./bag.svg": 10,
	"./burger": 11,
	"./burger.svg": 11,
	"./chevron-left": 12,
	"./chevron-left.svg": 12,
	"./close": 13,
	"./close.svg": 13,
	"./deliveroo-white": 14,
	"./deliveroo-white.svg": 14,
	"./email": 15,
	"./email.svg": 15,
	"./enlarge": 16,
	"./enlarge.svg": 16,
	"./facebook-social": 17,
	"./facebook-social.svg": 17,
	"./favicon": 18,
	"./favicon.svg": 18,
	"./footer-logo": 19,
	"./footer-logo.png": 19,
	"./gps": 20,
	"./gps.svg": 20,
	"./hero": 21,
	"./hero.jpg": 21,
	"./hygiene": 22,
	"./hygiene.png": 22,
	"./image-1": 23,
	"./image-1.jpg": 23,
	"./image-2": 24,
	"./image-2.jpg": 24,
	"./instagram-social": 25,
	"./instagram-social.svg": 25,
	"./just-eat-white": 26,
	"./just-eat-white.svg": 26,
	"./logo": 27,
	"./logo.svg": 27,
	"./messaging": 28,
	"./messaging.svg": 28,
	"./mini-tripadvisor": 29,
	"./mini-tripadvisor.svg": 29,
	"./open-graph-image": 30,
	"./open-graph-image.jpg": 30,
	"./payments/amex": 31,
	"./payments/amex.svg": 31,
	"./payments/apple-pay": 32,
	"./payments/apple-pay.svg": 32,
	"./payments/google-pay": 33,
	"./payments/google-pay.svg": 33,
	"./payments/mastercard-1": 34,
	"./payments/mastercard-1.svg": 34,
	"./payments/mastercard-2": 35,
	"./payments/mastercard-2.svg": 35,
	"./payments/paypal": 36,
	"./payments/paypal.svg": 36,
	"./payments/visa": 37,
	"./payments/visa.svg": 37,
	"./people": 38,
	"./people.svg": 38,
	"./shaded-background": 39,
	"./shaded-background.png": 39,
	"./star": 40,
	"./star.svg": 40,
	"./telephone": 41,
	"./telephone.svg": 41,
	"./tripadvisor-white": 42,
	"./tripadvisor-white.png": 42,
	"./upholstery": 43,
	"./upholstery.png": 43
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;